var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNucleusBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.889 3.61091L30.889 3.6109C30.1188 2.84062 29.0955 2.42743 27.517 2.21521C25.9242 2.00106 23.8425 2 21 2H15C12.1574 2 10.0758 2.00106 8.48299 2.21521C6.90456 2.42743 5.88121 2.84061 5.11091 3.61091C5.11091 3.61091 5.11091 3.61091 5.11091 3.61091M30.889 3.61091L5.11091 3.61091M30.889 3.61091C31.6594 4.38121 32.0726 5.40456 32.2848 6.98299C32.4989 8.57581 32.5 10.6574 32.5 13.5V19.5C32.5 22.3425 32.4989 24.4242 32.2848 26.017C32.0726 27.5955 31.6594 28.6188 30.8891 29.389L30.889 29.3891C30.1188 30.1594 29.0955 30.5726 27.517 30.7848C25.9242 30.9989 23.8425 31 21 31H15C12.1574 31 10.0758 30.9989 8.48299 30.7848C6.90456 30.5726 5.88121 30.1594 5.11091 29.389L5.1109 29.389C4.34062 28.6188 3.92743 27.5955 3.71521 26.017C3.50106 24.4242 3.5 22.3425 3.5 19.5V13.5C3.5 10.6574 3.50106 8.57581 3.71521 6.98299C3.92743 5.40456 4.34061 4.38121 5.11091 3.61091M30.889 3.61091L5.11091 3.61091",
    fill: "url(#paint0_linear_1965_50564)",
    stroke: "url(#paint1_linear_1965_50564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.6615 18.7007C11.5553 17.4022 13.0875 15.9944 14.9632 14.7481C16.839 13.5018 18.9257 12.5052 20.8218 11.95C22.7179 11.3948 24.2894 11.3203 25.2339 11.7408C26.1783 12.1613 26.429 13.0471 25.9375 14.2278C25.4461 15.4084 24.2473 16.8004 22.5719 18.136C20.8966 19.4715 18.863 20.6561 16.8626 21.4618C14.8622 22.2675 13.0364 22.6374 11.7364 22.5003C10.4365 22.3631 9.75442 21.7287 9.8214 20.719",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8465 8.30744C17.6821 7.56997 18.5941 7.65922 19.4056 8.55783C20.2171 9.45646 20.8702 11.1004 21.2383 13.1708C21.6064 15.2411 21.6632 17.5903 21.3977 19.7625C21.1321 21.9347 20.5632 23.7751 19.8012 24.9267C19.0393 26.0782 18.1386 26.4588 17.274 25.9947C16.4094 25.5305 15.6424 24.2547 15.1219 22.4147C14.6015 20.5746 14.3645 18.3016 14.4572 16.0366C14.5498 13.7715 14.9653 11.6759 15.6231 10.1563",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.5481 22.085C26.3189 21.5561 26.3907 20.5924 25.7499 19.3752C25.109 18.1579 23.7998 16.771 22.0684 15.4752C20.3371 14.1795 18.3029 13.0643 16.3486 12.3393C14.3942 11.6143 12.6544 11.3296 11.4563 11.5386C10.2581 11.7477 9.68432 12.4361 9.84274 13.4744C10.0012 14.5127 10.8809 15.8293 12.3165 17.1767C13.7521 18.524 15.6446 19.8092 17.6381 20.7904C19.6315 21.7717 21.5885 22.3814 23.141 22.505",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 7.66667C17.2539 7.66667 18.0001 8.41286 18.0001 9.33333C18.0001 10.2538 17.2539 11 16.3334 11C15.4129 11 14.6667 10.2538 14.6667 9.33333C14.6667 8.41286 15.4129 7.66667 16.3334 7.66667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 20.3333C24.5871 20.3333 25.3333 21.0795 25.3333 22C25.3333 22.9205 24.5871 23.6667 23.6667 23.6667C22.7462 23.6667 22 22.9205 22 22C22 21.0795 22.7462 20.3333 23.6667 20.3333Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 18.3333C11.2539 18.3333 12.0001 19.0795 12.0001 20C12.0001 20.9205 11.2539 21.6667 10.3334 21.6667C9.41294 21.6667 8.66675 20.9205 8.66675 20C8.66675 19.0795 9.41294 18.3333 10.3334 18.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_50564",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1965_50564",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNucleusBlueIcon);
export default __webpack_public_path__ + "static/media/nucleus_blue_icon.4e4c0ec574adbc2f6fd549a7757eee5d.svg";
export { ForwardRef as ReactComponent };